module.exports = __webpack_public_path__ + "img/MOS_Sample_Certificate_1.7ff3626c.png";